<template>
  <v-card>
    <v-data-table
      hide-default-footer
      :headers="headers"
      :items="mailSender"
      sort-by="name"
      class="elevation-1"
      v-if="mailSender.length > 0"
    >
      <template v-slot:item.actions="{ item }">
        <div class="d-flex">
          <v-icon small @click="edit(item)" class="mr-2"> mdi-pencil </v-icon>
        </div>
      </template>
      <template v-slot:item.mailType="{ item }">
        <div small dark>
          {{ item.mailType }}
        </div>
      </template>
      <template v-slot:item.contactUsTypes="{ item }">
        <div
          v-for="type in item.contactUsTypes"
          :key="type.id"
          small
          class="ma-1"
          dark
        >
          {{ type.name }}
        </div>
      </template>

      <template v-slot:top>
        <v-toolbar flat>
          <v-dialog v-model="confirmationDialogEdit" max-width="800px">
            <v-card class="dialog-class">
              <v-text-field v-model="editedMailSender.to" label="Mail To" />
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="red darken-1"
                  class="custom-button"
                  text
                  @click="closeEditedDialog"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1 white--text"
                  class="custom-button"
                  @click="submitData"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog" max-width="800px" height="5vh">
            <v-card class="dialog-class">
              <p>hhhh</p>

              <v-card-actions class="actions">
                <v-spacer />
                <v-btn
                  color="red darken-1"
                  class="custom-button"
                  text
                  @click="closeEditedDialog"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1 white--text"
                  class="custom-button"
                  @click="submitData"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
    </v-data-table>

    <v-snackbar>
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
          class="custom-button"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import MailSender from "../../../tenant/models/MailSender";
export default {
  title: "Tenants",
  data() {
    return {
      tenantCodeSelected: null,
      snackbar: false,
      snackbarText: ``,
      confirmMSG: "",
      dialogDelete: false,
      isManageActiveStatus: false,
      dialog: false,
      confirmationDialogEdit: false,
      editedMailSender: new MailSender(),
      headers: [
        { text: "From", value: "from" },
        { text: "To", value: "to" },
        { text: "type", value: "mailType" },
        { text: "Contact Us Types", value: "contactUsTypes" },
        {
          text: "actions",
          align: "start",
          sortable: false,
          value: "actions",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("tenant", ["mailSender"]),
  },
  async mounted() {
    await this.loadMailSender();
  },
  methods: {
    async loadMailSender() {
      await this.$store.dispatch("tenant/loadMailSenderConfiguration");
    },
    edit(item) {
      this.confirmationDialogEdit = true;
      this.editedMailSender = item;
    },

    closeEditedDialog() {
      this.confirmationDialogEdit = false;
      this.editedMailSender = new MailSender();
    },
    async submitData() {
      let payLoad = {
        id: this.editedMailSender.id,
        to: this.editedMailSender.to,
      };
      await this.$store.dispatch("tenant/editMailSenderConfiguration", payLoad);
      await this.closeEditedDialog();
    },
  },
};
</script>
<style scoped>
.selectBox {
  padding: 2rem;
}
.create-websiteS3 {
  color: white;
  margin: 2rem;
}
.custom-button {
  border-radius: 3.125rem;
}
</style>
